export default {
  title: 'Adjust Order',
  product_info: {
    earn_points: 'Earn {{points}} Points',
  },
};
